// The range of the integer column the quantity is stored in
const QUANTITY_MAX = 2147483647;
const QUANTITY_RE = /^\d*$/;

/** Whether what stands in the field can still become a count — half-typed is not yet wrong. */
export const isQuantityValid = (value: string): boolean => (
  QUANTITY_RE.test(value) && (value === '' || Number(value) <= QUANTITY_MAX)
);

/** The boxes are counted for every recorded pallet, so an empty field cannot be saved. */
export const isQuantityProvided = (value: string): boolean => (
  value !== '' && isQuantityValid(value)
);

export const parseQuantity = (value: string): number | null => (
  value === '' ? null : Number(value)
);

export const formatQuantity = (quantity: number | null | undefined): string => (
  quantity == null ? '' : String(quantity)
);
